<template>
  <v-menu
    v-model="userProfileMenuIsOpen"
    bottom
    left
    offset-y
    open-on-click
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ attrs, on }">
        <v-btn
          min-width="0"
          v-bind="attrs"
          v-on="on"
          icon
        >
          <v-avatar :color="userInfo.avatar.color" left>
            <span class="white--text headline">{{ userInfo.avatar.initials }}</span>
          </v-avatar>
        </v-btn>
    </template>

    <v-list
      :tile="false"
      nav
    >
      <DarkListItem>
        <v-btn
          text
          class="ma-0 pa-0"
          :ripple="false"
          target="_blank"
          href="https://profile-northcentralus-sandbox.azurewebsites.net/profile/result.aspx"
        >
          My Profile Report
        </v-btn>
      </DarkListItem>
      <DarkListItem>
        <v-btn
          text
          class="ma-0 pa-0 text-md-center"
          :ripple="false"
          @click="handleLogout"
          href="/id/initLogout"
        >
          Logout
        </v-btn>
      </DarkListItem>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DarkListItem from './utils/DarkListItem'

export default {
  name: 'Notifications',

  components: {
    DarkListItem
  },

  data: () => ({
    userProfileMenuIsOpen: false
  }),

  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo
    })
  },

  methods: {
    ...mapActions(['authLogout']),

    handleLogout () {
      this.authLogout()
      // this.$router.push('/')
      window.location.href = '/id/initLogout'
    }
  }
}
</script>

<style lang="sass" scoped>
  .v-btn:before
    display: none
</style>
